import type { PageContext, SuggestionBubble } from '@/features/ai/types'

/**
 * Suggestion bubbles surfaced in the Noah empty state on case detail.
 *
 * Function form (not a static array) so future iterations can read the live
 * `PageContext` (e.g. case_id) and tailor labels/prompts to the active case.
 * v1 returns a static list.
 *
 * Two OPENERS, matching the Search surface. Both stay inside what the chat
 * agent demonstrably has — case fields, evidence, similar cases. Nothing here
 * asks what the automation did: Noah is automation-blind, exactly like the
 * investigation agent (ADR 0017 dec. 2).
 */
export const getCaseBubbles = (_ctx: PageContext): Array<SuggestionBubble> => [
	{
		id: 'case.summarize-case',
		label: 'Summarize this case',
		prompt:
			'Summarize this case. Cover the trigger, the involved entities, and any notable indicators.',
	},
	{
		id: 'case.similar-past-cases',
		label: 'Find similar past cases',
		prompt:
			'Find similar past cases. Highlight common entities, patterns, and prior outcomes.',
		requires: 'search',
	},
]
